import { render } from "./MainNavbar.vue?vue&type=template&id=356b66c6"
import script from "./MainNavbar.vue?vue&type=script&lang=js"
export * from "./MainNavbar.vue?vue&type=script&lang=js"

import "./MainNavbar.vue?vue&type=style&index=0&id=356b66c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__